import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAppSelector } from '../../hooks/useAppSelector';
import RestroLiteAdminPage from '../superAdmin/RestroLiteAdminPage';

export default function EmployeeRestroLiteShopsPage() {
  const { user } = useAppSelector((state) => state.auth);
  if (!user?.permissions?.tabs?.restroLiteShops) {
    return <Navigate to="/employee/dashboard" replace />;
  }
  return <RestroLiteAdminPage employeeMode />;
}
